import { Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import BlogItem from "./BlogItem";
import { tokens } from "../../../store/tokens";
import { bodyText, buttonSx, heading } from "../../../store/presetsNew";

const gridContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};
const gridItem = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

const LatestBlogNews = () => {
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);

  useEffect(() => {
    fetch(
      `https://aps.songjukti.com/profile/login/api_spForum/fun_blog.php?requ_type=allTopBlog`
    )
      .then((res) => res.json())
      .then((result) => {
        setBlogData(result);
      })
      .catch((error) => console.log("BlogData Error => ", error));
  }, []);

  return (
    <Box mt={{ xs: 6, md: 8 }}>
      {blogData?.length >= 1 && (
        <Box>
          <Stack
            component={motion.div}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5 }}
            justifyContent="center"
            alignItems="center"
            sx={{ px: 2, textAlign: "center", gap: 1.25, mb: { xs: 3, md: 4 } }}
          >
            <Typography sx={{ ...heading("h2"), fontSize: { xs: "1.7rem", md: tokens.type.h2.fontSize } }}>
              Latest blog news
            </Typography>
            <Typography sx={{ ...bodyText("body1"), maxWidth: 560 }}>
              Trends and the tech skills worth mastering next
            </Typography>
          </Stack>

          <Container>
            <Grid
              container
              spacing={3}
              component={motion.div}
              variants={gridContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.15 }}
            >
              {blogData.map((element) => (
                <Grid item xs={12} sm={6} md={4} key={element.pic} component={motion.div} variants={gridItem} whileHover={{ y: -4 }}>
                  <BlogItem blogData={element} />
                </Grid>
              ))}
            </Grid>
          </Container>

          <Stack direction="row" justifyContent="center" mt={{ xs: 3, md: 4 }}>
            <Button
              component={motion.button}
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate("/bloglist")}
              sx={buttonSx("lg", "solid")}
            >
              Load more
            </Button>
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default LatestBlogNews;